import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const submitContact = (data) => api.post("/contact", data).then((r) => r.data);
export const subscribeNewsletter = (email) => api.post("/newsletter", { email }).then((r) => r.data);
export const submitQuiz = (data) => api.post("/quiz", data).then((r) => r.data);
export const fetchInsights = (params = {}) => api.get("/insights", { params }).then((r) => r.data);
export const fetchInsight = (slug) => api.get(`/insights/${slug}`).then((r) => r.data);

// ---------- Admin ----------
const TOKEN_KEY = "td_admin_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);
const authCfg = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

// Global 401 handler — if any admin request comes back as expired/invalid session,
// clear the token and force a redirect to /admin so the user re-logs in cleanly.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    if (status === 401 && (url.startsWith("/admin") || url.startsWith("/auth/me"))) {
      clearToken();
      if (typeof window !== "undefined" && window.location.pathname.startsWith("/admin")) {
        // Give the toast a beat to fire before redirect
        setTimeout(() => window.location.reload(), 800);
      }
    }
    return Promise.reject(err);
  }
);

export const adminLogin = (email, password) =>
  api.post("/auth/login", { email, password }).then((r) => r.data);
export const adminMe = () => api.get("/auth/me", authCfg()).then((r) => r.data);

export const adminListInsights = () => api.get("/admin/insights", authCfg()).then((r) => r.data);
export const adminCreateInsight = (data) => api.post("/admin/insights", data, authCfg()).then((r) => r.data);
export const adminUpdateInsight = (id, data) => api.put(`/admin/insights/${id}`, data, authCfg()).then((r) => r.data);
export const adminDeleteInsight = (id) => api.delete(`/admin/insights/${id}`, authCfg()).then((r) => r.data);
export const adminGenerateCover = (data) => api.post("/admin/generate-cover", data, authCfg()).then((r) => r.data);

export const adminSubscribers = () => api.get("/admin/subscribers", authCfg()).then((r) => r.data);
export const adminContacts = () => api.get("/admin/contacts", authCfg()).then((r) => r.data);
export const adminQuiz = () => api.get("/admin/quiz", authCfg()).then((r) => r.data);
export const adminLeadMagnets = () => api.get("/admin/lead-magnets", authCfg()).then((r) => r.data);

export const adminExport = async (dataset) => {
  const res = await api.get(`/admin/export/${dataset}`, { ...authCfg(), responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = `${dataset}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const resolveImg = (src) => (src && src.startsWith("/") ? `${BACKEND_URL}${src}` : src);
